// Imports
import firebase from '../config/FirebaseConfig'
import AxiosConfig from '../foreplayServer/serverAxiosConfig'

// Setup
const db = firebase.firestore()

// Get All By User
const getAllCreatedByUser = async (teamId) => {
  const user = firebase.auth().currentUser

  if (!user) return []

  const snapshot = await db.collection('invitations')
    .where('teamId', '==', teamId)
    .where('status', '==', 'pending')
    .get()

  return snapshot.docs?.map(doc => {
    return {
      id: doc.id,
      ...doc.data() || []
    }
  })
}

const getUserInvitations = async () => {
  const user = firebase.auth().currentUser

  if (!user) return []

  const snapshot = await db.collection('invitations')
    .where('toEmail', '==', user.email.toLocaleLowerCase())
    .where('status', '==', 'pending')
    .get()

  return snapshot.docs?.map(doc => {
    return {
      id: doc.id,
      ...doc.data() || []
    }
  })
}

const remove = async (invitationId) => {
  return db.collection('invitations').doc(invitationId).delete()
}

const reject = async (invitationId) => {
  return db.collection('invitations').doc(invitationId).update({ status: 'rejected' })
}

const accept = async (invitationId) => {
  return db.collection('invitations').doc(invitationId).update({ status: 'accepted' })
}

const getInvitationById = async (invitationId) => {
  const user = firebase.auth().currentUser
  if (!user) throw new Error('Not Authorized. Refresh the page and try again.')

  const token = await user.getIdToken()

  const { data } = await AxiosConfig.get(`/fs/invitations/${invitationId}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  return data
}

const ignoreAll = async (allInvitations) => {
  if (!Array.isArray(allInvitations) || allInvitations.length === 0) return []

  const validInvitations = allInvitations.filter(invitation => invitation?.id)
  if (validInvitations.length === 0) return []

  const user = firebase.auth().currentUser
  if (!user) throw new Error('Not Authorized. Refresh the page and try again.')

  const token = await user.getIdToken()

  return Promise.all(
    validInvitations.map(invitation => {
      return AxiosConfig.post(`/team/invite/${invitation.id}/respond`, {
        action: 'rejected'
      }, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
    })
  )
}

export default {
  accept,
  getAllCreatedByUser,
  getUserInvitations,
  reject,
  remove,
  getInvitationById,
  ignoreAll
}
